import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import DialogCustom from '../../../../dialog/Dialog'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import InputDateUTC from '../../../../FormControl/input/InputDateUTC'
import AutocompleteField from '../../../../FormControl/input/AutocompleteField'
import SelectField from '../../../../FormControl/input/SelectField'
import useFetchData from '../../../../../hooks/useFetchData'
import { useDispatch, useSelector } from 'react-redux'
import { updateFilter, showFilter } from '../../../../../store/actions/filter.actions'
import { useLocation, useNavigate } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import { updateSkip } from '../../../../../store/actions/datatable.actions'
import { capitalizarPrimeraLetra } from '../../../../../utils'
import InputField from '../../../../FormControl/input/InputField'

const FilterDialog = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const date = useSelector(state => state?.date?.date || new Date())
  const filter = useSelector(state => state?.filter.maintenance?.filter || {})
  const open = useSelector(state => state?.filter.maintenance?.open || false)
  const dispatch = useDispatch()

  const [form, setInputForm] = useState(filter)
  const [error, setInputError] = useState({ })

  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter)
    }
  }, [filter])

  const onClose = () => {
    dispatch(showFilter('maintenance', false))
  }

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value })
    setInputError({ ...error, [name]: null })
  }

  const onApply = () => {
    dispatch(updateFilter('maintenance', form));
    dispatch(updateSkip('maintenance', 0));
    navigate(pathname, { state: form });
    onClose()
  }

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        startIcon={["fal","times"]}
      >
        Cancel
      </ButtonStartIcon>
      <ButtonStartIcon
        onClick={onApply}
        color='primary'
        variant='contained'
        startIcon={["fal","check"]}
      >
        Apply
      </ButtonStartIcon>
    </>
  )

  return (
    <DialogCustom
      id='maintenance-log-filter'
      show={open} 
      title="Filter"
      onClose={onClose}
      actions={Actions}
    >
      <Box className='flex flex-col gap-4 py-4'>
        <div className='grid grid-cols-3 items-start gap-4'>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            start date
          </Typography>
          <div className='col-span-2'>
            <InputDateUTC
              id='form-filter-start-date'
              name="startDate"         
              value={form.startDate}  
              error={error.startDate}
              helperText={error.startDate}                          
              maxDate={date}
              onChange={(value) => onChange("startDate", value)}       
            />     
          </div>
        </div>
        <div className='grid grid-cols-3 items-start gap-4'>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            end date
          </Typography>
          <div className='col-span-2'>
            <InputDateUTC
              id='form-filter-end-date'
              name="endDate"         
              value={form.endDate}  
              error={error.endDate}
              helperText={error.endDate}                          
              minDate={form.startDate}
              maxDate={date}
              isStartOfTheDay={false}
              onChange={(value) => onChange("endDate", value)}       
            />     
          </div>
        </div>
        <div className='grid grid-cols-3 items-start gap-4'>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            module
          </Typography>
          <div className='col-span-2'>
            <SelectField 
              id='form-filter-module'
              name="module"       
              error={error.module}
              helperText={error.module}                    
              value={form.module}
              onChange={(e) => onChange("module", e.target.value)}    
              placeholder={'Choose a module'} 
              options={[
                { label: 'Class', value: 'class' },
                { label: 'User', value: 'user' },
              ]} 
            /> 
          </div>
        </div>
        <div className='grid grid-cols-3 items-start gap-4'>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            action
          </Typography>
          <div className='col-span-2'>
          <SelectField 
              id='form-filter-action'
              name="action"       
              error={error.action}
              helperText={error.action}                    
              value={form.action}
              onChange={(e) => onChange("action", e.target.value)}    
              placeholder={'Choose a action'} 
              options={[
                { label: 'Sync maintenance', value: 'sync maintenance' },
                { label: 'Disable maintenance', value: 'disable maintenance' },
              ]} 
            /> 
          </div>
        </div>
        <div className='grid grid-cols-3 items-start gap-4'>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            status
          </Typography>
          <div className='col-span-2'>
            <SelectField 
              id='form-filter-status'
              name="status"       
              error={error.status}
              helperText={error.status}                    
              value={form.status}
              onChange={(e) => onChange("status", e.target.value)}    
              placeholder={'Choose a status'} 
              options={[
                { label: 'Success', value: 'success' },
                { label: 'Executing', value: 'executing' },
                { label: 'Pending', value: 'pending' },
                { label: 'Failed', value: 'failed' },
              ]} 
            /> 
          </div>
        </div>
      </Box>
    </DialogCustom>
  )
}

export default FilterDialog

